import { useMemo } from 'react';
import { useMantineTableWithPaginationFilteringSorting } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useSecurityTypeTranslation } from '@dealstack/frontend/shared/translationControllers/useCommonTranslationsController.ts';
import { getSecuritiesTableColumns } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Securities/components/SecuritiesTable/getSecuritiesTableColumns.tsx';
import { SecurityFormData } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Securities/types.ts';

interface SecurityFilterDto {
	type?: string[];
	name?: string;
	isSubjectToVesting?: string[];
}

interface Props {
	onEdit: (security: SecurityFormData) => void;
	onToggleVesting: (security: SecurityFormData) => void;
}

export const useSecuritiesTableState = ({ onEdit, onToggleVesting }: Props) => {
	const tMipManage = useTranslationMipManage();
	const getSecurityTypeTranslation = useSecurityTypeTranslation();

	const columns = useMemo(
		() =>
			getSecuritiesTableColumns({
				tMipManage,
				getSecurityTypeTranslation,
				handlers: { onEdit, onToggleVesting },
			}),
		[tMipManage, getSecurityTypeTranslation, onEdit, onToggleVesting]
	);

	const initialTableOptions = {
		initialSorting: [{ id: 'createdAt', desc: false }],
	};

	const { mantineTableDataOperations } = useMantineTableWithPaginationFilteringSorting<
		SecurityFormData,
		SecurityFilterDto
	>(columns, initialTableOptions, false);

	return {
		columns,
		mantineTableDataOperations,
	};
};
